import React from 'react';
import { ExternalLink } from 'lucide-react';
import { projects } from '../../mock';

const ProjectsSection = () => {
  return (
    <section id="projects" className="py-24 px-6">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-center mb-16">Selected work</h2>
        
        {/* Projects Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {projects.map((project) => (
            <div
              key={project.id}
              className="glass-card overflow-hidden group hover:scale-[1.02] transition-all duration-300"
            >
              {/* Project Image */}
              <div className="relative h-48 overflow-hidden bg-[#1A1430]">
                <img
                  src={project.image}
                  alt={project.name}
                  loading="lazy"
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                
                {/* Category Badge */}
                <div className="absolute top-4 left-4">
                  <span className="px-4 py-1.5 bg-[#0E0B1F]/80 backdrop-blur-sm text-[#7C3AED] rounded-full text-sm font-medium border border-[#7C3AED]/30">
                    {project.category}
                  </span>
                </div>
              </div>
              
              {/* Project Details */}
              <div className="p-6">
                <h3 className="text-2xl font-semibold text-[#EDE9FE] mb-4" style={{ fontFamily: 'Geist, Inter, sans-serif' }}>
                  {project.name}
                </h3>
                
                {/* Challenge / Approach / Outcome */}
                <div className="space-y-3 mb-6">
                  <div>
                    <span className="text-sm text-[#9D97B5] font-medium">Challenge:</span>
                    <p className="text-[#EDE9FE]">{project.challenge}</p>
                  </div>
                  
                  <div>
                    <span className="text-sm text-[#9D97B5] font-medium">Approach:</span>
                    <p className="text-[#EDE9FE]">{project.approach}</p>
                  </div>
                  
                  <div>
                    <span className="text-sm text-[#9D97B5] font-medium">Outcome:</span>
                    <p className="text-[#22D3A5] font-medium">{project.outcome}</p>
                  </div>
                </div>
                
                {/* Visit Link */}
                <a
                  href={project.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 text-[#7C3AED] hover:text-[#C026D3] font-medium transition-colors group/link"
                >
                  Visit project
                  <ExternalLink size={16} className="group-hover/link:translate-x-1 transition-transform" />
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProjectsSection;
